import { useIntl } from 'react-intl';
import React from 'react';
import { messages } from '../../../i18n/messages';
import { insertLinkIntoMessage } from '../../../util';
import styles from './FeedbackDisplay.module.scss';

export const FeedbackDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const intl = useIntl();
    const contactOrganizerUrl = `/help/${helpCenterLanguage}/articles/647151/how-to-contact-the-event-organizer/`;
    const linkText = intl.formatMessage(messages['here']);
    const linkTitle = intl.formatMessage({
        id: 'Link to contacting the organizer',
        defaultMessage: 'Link to contacting the organizer',
    });
    const link = (
        <a
            href={contactOrganizerUrl}
            rel="noopener noreferrer"
            target="_blank"
            title={linkTitle}
            aria-label={linkTitle}
        >
            {linkText}
        </a>
    );
    const message = intl.formatMessage(
        {
            id: 'Questions about the online event link, event location, or event details? Have feedback about the event? Learn how to contact the event organizer {link}',
            defaultMessage: 'Questions about the online event link, event location, or event details? Have feedback about the event? Learn how to contact the event organizer {link}',
        },
        {
            link: linkText,
        }
    );

    return (
        <p className={styles.feedbackText} data-testid="reason_feedback-radio">
            {insertLinkIntoMessage(message, linkText, link)}.
        </p>
    );
};
